import React from "react";
import "./CitiesList.css";
const DistrictsList = () => {
  const cities = [
"Belagavi",
"Bellary",
"Davangere",
"Hubballi",
"Mangalore",
"Mysore",
"Shivamogga",
"Dharwad",
"Manipal",
"Raichur",
"Ullal",
"Udupi",
"Kalaburagi",
"Bhatkal",
"Vijayapura",
"Hassan",
"Kolar",
"Chikkamagaluru",
"Hosapete",
"Channapatna",
"Bidar",
"Karwar",
"Mandya",
"Bramavara",
"Kundapura",
"Bhadravathi",
"Sirsi",
"Bagalkote",
"Chamarajanagar",
"Chikkaballapur",
"Chitradurga",
"Dakshina Kannada",
"Davanagere",
"Gadag",
"Haveri",
"Madikeri",
"Koppal",
"Ramanagara",
"Tumakuru",
"Yadgir",
"Vijayanagara",
"Dandeli",
"Puttur",
"Bhadravati",
"Sagar",
"Ranebennur",
"Gokak",
"Nelamangala",
"Devanahalli",
"Anekal",
  ];
  return (
    <section className="citiesList-container">
      <h2 className="citiesList-title">
        1 Day Free Pick-Up from Karnataka Districts{" "}
      </h2>

      <div className="citiesList-grid">
        {cities.map((city, index) =>
          city === "Book a Free Visit" ? (
            <button key={index} className="city-card book-visit-btn">
              {city}
            </button>
          ) : (
            <div key={index} className="city-card">
              {city}
            </div>
          ),
        )}
      </div>
    </section>
  );
};

export default DistrictsList;
